import React from 'react'

import './loading.css'

const Component = (props) => {
  return (
    <div className="load-container">
      <div className="load-08"></div>
    </div>
  )
}

export default Component